import { setLanguageBundle } from '@nackle/intl-tools';
export default async function( token, environment, locale ) {

    try {
        const response = await fetch( `https://${ environment && environment !== 'prod' ? `${ environment }.` : '' }api.biw.cloud/v2/cmx/bundle/${ encodeURIComponent( 'celebrations-widget' ) }`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ token }`
            },
            body: JSON.stringify( { locales: [ locale ] } )
        } );
        if ( response.ok ) {
            const bundle = await response.json();

            setLanguageBundle( locale, bundle.bundles[ locale ] );
            return { success: true };
        } else {
            return { success: false };
        }
    } catch ( error ) {
        return { success: false };
    }
}
